import service from '@/api/axios';
import { postSendOrder } from '@/api/network/common'
import store from "@/store"

//  根据耗材版本号获取耗材sku列表
export function lanNetworkIndex (data) {
  return service({
    url: '/v3/lan_network/index',
    method: 'post',
    data
  })
}

//  自动续料
function http_setAutoFeed (boxId, autoFeed) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1212',
    data: {
      multi_color_box: [
        {
          id: boxId, //料盒ID，主料盒为0，从料盒为1
          auto_feed: autoFeed ? 1 : 0 //0 关闭 1 开启
        }
      ]
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

//  轴移动
function http_move (axis, move_type, distance) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '201',
    data: { axis, move_type, distance },
    printer_id: id  //  后续需要动态获取机器id
  })
}

//  关闭电机
function http_turnOff () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1213',
    printer_id: id //  后续需要动态获取机器id
  })
}

//  开启/关闭烘干
function http_setDry (boxId, status, targetTemp, duration) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  const params = status === 1
    ? {
      status, //0 关闭,1 开启
      target_temp: targetTemp,
      duration
    }
    : {
      status, //0 关闭,1 开启
    }
  return postSendOrder({
    order_id: '1207',
    data: {
      multi_color_box: [
        {
          id: boxId,
          drying_status: params
        }
      ]
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

//  设置单个料槽信息
function http_setInfo (boxId, index, type, color) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1211',
    data: {
      multi_color_box: [
        {
          id: boxId,
          slots: [
            {
              index,
              type,
              color
            }
          ]
        }
      ]
    },
    printer_id: id
  })
}

//  多色盒子进料操作
function http_feedFilament (boxId, index, type) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1208',
    data: {
      multi_color_box: [
        {
          id: boxId, //料盒ID，主料盒为0，从料盒为1
          feed_status: {
            slot_index: index, //料槽index
            type, //1 进料 2 退料 3 结束进/退料
          }
        }
      ]
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

// 外置料架进料操作
function http_replaceFilament (type) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1215',
    data: {
      type, //1 进料 2 退料 3 结束(完成)进/退料
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

//  外置盒子信息
function http_getInfoExtfilbox () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1230',
    data: null,
    printer_id: id //  后续需要动态获取机器id
  })
}

//  设置多色打印机外置料架信息
function http_setExtfilbox (type, color) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1229',
    data: {
      type,
      color
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

//  获取多色盒子的信息
function http_getInfoMultiColorBox () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1206',
    data: null,
    printer_id: id //  后续需要动态获取机器id
  })
}

//  获取设备外设状态（camera,udisk等）
function http_peripherie () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1231',
    data: null,
    printer_id: id //  后续需要动态获取机器id
  })
}

//  灯光查询
function http_light () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1232',
    data: null,
    printer_id: id //  后续需要动态获取机器id
  })
}

//  零件查询
function http_query_obj () {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1236',
    data: null,
    printer_id: id //  后续需要动态获取机器id
  })
}

//  零件跳过
function http_skip_start (arr) {
  const { id } = store?.getters?.GET_CUR_PRINTER || {}
  return postSendOrder({
    order_id: '1238',
    data: {
      objects_skip_parts: [...arr] //跳过的零件
    },
    printer_id: id //  后续需要动态获取机器id
  })
}

const http_fuction = {
  http_getInfoExtfilbox,
  http_getInfoMultiColorBox,
  http_peripherie,
  http_setExtfilbox,
  http_setInfo,
  http_feedFilament,
  http_replaceFilament,
  http_setDry,
  http_setAutoFeed,
  http_turnOff,
  http_move,
  http_light,
  http_skip_start,
  http_query_obj
}

export default http_fuction